import $ from 'jquery';
import 'slick-carousel';

// Similar Vehicles

if ($('.blog-categories')) {
  const types = [];

  $('.blog-categories')
    .find('.blog-category')
    .each(function () {
      types.push($(this).data('index'));
    });

  types.forEach((type) => {
    const $blogCategorySlider = $(`.blog-category-slider-${type}`);

    const $blogCurrentCategorySlide = $(`.blog-category-slider-${type}-current-item`);

    $blogCategorySlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      nextArrow: $(`.slide-m-next-blog-category-slider-${type}`),
      prevArrow: $(`.slide-m-prev-blog-category-slider-${type}`),

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $blogCategorySlider.on(
      'init reInit afterChange beforeChange',
      function (event, slick, currentSlide) {
        const current = (currentSlide ? currentSlide : 0) + 1;
        $blogCurrentCategorySlide.text(current + '/' + slick.slideCount);
      }
    );
  });
}
